import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  template: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const PostTemplateSlice = createSlice({
  name: "postTemplate",
  initialState: INITIAL_STATE,
  reducers: {
    postTemplateData: (state) => {
      state.template.isLoading = true;
    },
    postTemplateSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      template: {
        ...state.template,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    postTemplateFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      template: {
        ...state.template,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    putTemplateData: (state) => {
      state.template.isLoading = true;
    },
    putTemplateSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      template: {
        ...state.template,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    putTemplateFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      template: {
        ...state.template,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    deleteTemplateData: (state) => {
      state.template.isLoading = true;
    },
    deleteTemplateSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      template: {
        ...state.template,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    deleteTemplateFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      template: {
        ...state.template,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const {
  postTemplateData,
  postTemplateFailure,
  postTemplateSuccess,
  putTemplateData,
  putTemplateFailure,
  putTemplateSuccess,
  deleteTemplateData,
  deleteTemplateFailure,
  deleteTemplateSuccess,
} = PostTemplateSlice.actions;
export const PostTemplateReducer = PostTemplateSlice.reducer;
